// Desktop Tab Nav
document.addEventListener('click', e => {
    if (e.target.closest('.js-d-tab') === null) {
        return
    }

    const btn = e.target.closest('.js-d-tab')
    const container = e.target.closest('.js-st-tabs')

    // Update active button
    const allButtons = container.querySelectorAll('.js-d-tab')
    allButtons.forEach(button => {
        if (button.classList.contains('is-active')) {
            button.classList.remove('is-active')
        }
    });

    if (btn.classList.contains('is-active') === false) {
        btn.classList.add('is-active')
    }

    // Show active tab
    const index = parseInt(btn.dataset.index)
    tabContentSlides.slideTo(index)
})